// js/custom-element/section/product-recommendations/product-recommendations.js
(function() {
  const init = function() {
    if (!window.customElements.get("product-recommendations")) {
      var ProductRecommendations = class extends HTMLElement {
        async connectedCallback() {
          if (!this.hasAttribute("use-automatic-recommendations") || !this.productId) {
            return;
          }
          const response = await fetch(`${window.themeVariables.routes.productRecommendationsUrl}?product_id=${this.productId}&limit=${this.recommendationsCount}&section_id=${this.sectionId}`);
          const div = document.createElement("div");
          div.innerHTML = await response.text();
          const productRecommendationsElement = div.querySelector("product-recommendations");
          if (productRecommendationsElement && productRecommendationsElement.hasChildNodes()) {
            this.innerHTML = productRecommendationsElement.innerHTML;
            this.removeAttribute("hidden");
          }
        }
        get productId() {
          return this.getAttribute("product-id");
        }
        get sectionId() {
          return this.getAttribute("section-id");
        }
        get recommendationsCount() {
          return parseInt(this.getAttribute("recommendations-count") || 4);
        }
      };
      window.customElements.define("product-recommendations", ProductRecommendations);
    }
  }
  if (window.criticalLoaded) { init() }
  else { document.addEventListener("critical-js:loaded", init); }
})();